<template>
    <AllPurchashing></AllPurchashing>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const AllPurchashing = defineAsyncComponent(() =>
    import("../../components/Purchasing/PurchashingTable.vue")
);

export default {
    name: "All_Purchashing",
    components: { AllPurchashing, AuthLayout },
};
</script>
